import { render } from "./Models.vue?vue&type=template&id=1b5bbe00"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"

import "./Models.vue?vue&type=style&index=0&id=1b5bbe00&lang=css"
script.render = render

export default script